// Copyright (C) 2012-2026 Zammad Foundation, https://zammad-foundation.org/

export const neutralColors = [
  {
    value: 'rgb(102, 102, 102)',
    label: __('Change text color to neutral (%s)'),
  },
  {
    value: 'rgb(153, 153, 153)',
    label: __('Change text color to neutral (%s)'),
  },
  {
    value: 'rgb(204, 204, 204)',
    label: __('Change text color to neutral (%s)'),
  },
]
